<template>
    <div class="filter-form-group form-group">
        <label
            v-for="(filterItem, index) in filterItems"
            :key="`filter-item-${index}`"
            :class="[
                {
                    'hidden': (index >= 4 && !showMore),
                    'checked': query[filterKey].includes(filterItem.key)
                },
                'checkbox'
            ]"
        >
            <input
                v-model="query[filterKey]"
                @change="handleFilter"
                :value="filterItem.key"
                type="checkbox"
            >

            {{ filterItem.title }}
        </label>
        <button
            v-if="filterItems.length > 4"
            @click="showMore = !showMore"
            :class="[
                { show: showMore },
                'form-group-show-more d-flex align-items-center justify-content-between'
            ]"
        >
            {{ showMore ? $t('category.show_less') : $t('category.show_more') }}
            <chevron-down-icon />
        </button>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import { ChevronDownIcon } from 'vue-feather-icons';

    export default {
        name: 'SearchFilterItems',
        components: {
            ChevronDownIcon,
        },
        data() {
            return {
                query: {},
                showMore: false,
            };
        },
        props: {
            filterItems: {
                type: Array,
                required: true,
            },
            filterKey: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('filters', {
                originalQuery: 'query',
            }),
        },
        methods: {
            ...mapActions('filters', [
                'getResults',
            ]),

            ...mapMutations('filters', [
                'updateQuery',
            ]),

            cloneQuery() {
                this.query = JSON.parse(JSON.stringify(this.originalQuery));
            },

            handleFilter() {
                clearTimeout(this.debouncer);

                this.debouncer = setTimeout(() => {
                    this.query.page = 1;
                    this.updateQuery(this.query);
                    this.getResults();
                }, 300);
            },
        },
        watch: {
            originalQuery: {
                handler: 'cloneQuery',
                immediate: true,
            },
        },
    };
</script>
